module.exports = __webpack_public_path__ + "img/113-greenland.76e26e9b.svg";